// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PostPrompt-cls1__c3af3e24fbf36c400530{/*!*/}.PostPrompt-cls2___ab5bce2f1b928ecdd4c{width:100%;padding:9px 12px;text-align:left;color:#535366;background-color:#fff;border-radius:4px;border:1px solid #b1b1ba;cursor:text}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "PostPrompt-cls1__c3af3e24fbf36c400530",
	"cls2": "PostPrompt-cls2___ab5bce2f1b928ecdd4c PostPrompt-cls1__c3af3e24fbf36c400530"
};
export default ___CSS_LOADER_EXPORT___;
